<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="充电站:" :label-width="60">
				<Select filterable placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text"  style="width: 180px;" v-model="formInline.OrderNo" placeholder="订单单号">
				<span slot="prepend">订单单号</span>
				</Input>
			</FormItem>
			<!-- <FormItem label="开始时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeBegin"></DatePicker>
			</FormItem> -->
			<!-- <FormItem label="结束时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeEnd"></DatePicker>
			</FormItem> -->
			<FormItem label="选择时间" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<FormItem>
				<Input type="text" style="width: 150px;" v-model="formInline.MemberName" placeholder="会员名称">
				<span slot="prepend">会员名称</span>
				</Input>
			</FormItem>
			<FormItem>
				<Input type="text" style="width: 150px;" v-model="formInline.EquipmentNo" placeholder="设备编号">
				<span slot="prepend">设备编号</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
			</FormItem>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight" ref="ChargingOrder"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getEvcsChargeOrderUrl" @listData='getDeviceData'></MyPage>
		<echartModal ref="echartModal" curvesName="EvcsChargeOrder"></echartModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import Qs from 'qs'
	import expandRow from './EvcsChargeOrderTemplate/EvcsChargeOrderExpand.vue';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
			echartModal
		},
		data() {
			return {
				getEvcsChargeOrderUrl: webapi.base_api_url + '/Order/GetEvcsChargeOrder',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				BreadcrumbList: ['订单记录', '>>', '互联互通订单'],
				formInline: {
					StationId: 0,
					OrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					MemberName: '',
					EquipmentNo: ''
				},
				//table标题数据
				columns1: [{
						type: 'expand',
						width: 50,
						render: (h, params) => {
							return h(expandRow, {
								props: {
									row: params.row
								}
							})
						}
					}, {
						title: '订单单号',
						key: 'OrderNo',
						minWidth: 120,
					}, {
						title: '订单时间',
						key: 'OrderTime',
						minWidth: 120,
					},
					{
						//title: '订单来源',
						title: '流量方运营商',
						key: 'EvcsOperatorName',
						minWidth: 120,
						// render: (h, params) => {
						// 	return h('div', params.row.EvcsOperatorName);
						// }
					},
					{
						title: '订单状态',
						key: 'OrderStatus',
						minWidth: 120,
						render: (h, params) => {
							return h('div', params.row.OrderStatusDesc);
						}
					},
					// {
					// 	title: '会员手机号码',
					// 	key: 'MemberPhone',
					// 	minWidth: 120,
					// },
					{
						title: '同步状态',
						key: 'SyncStatusDesc',
						minWidth: 120,
					},
					// {
					// 	title: '预付金额(元)',
					// 	key: 'OrderAmount',
					// 	minWidth: 120,
					// },
					{
						title: '充电总费用(元)',
						key: 'ChargeCost',
						minWidth: 120,
					},
					// {
					// 	title: '优惠金额',
					// 	key: 'CouponAmount',
					// 	minWidth: 120,
					// },
					// {
					// title: '结算金额',
					// 	key: 'CouponCost',
					// 	minWidth: 120,
					// },
					// {
					// 	title: '车牌号',
					// 	key: 'CarNo',
					// },
					// {
					// 	title: 'VIN',
					// 	key: 'VIN',
					// },
					{
						title: '枪编号',
						key: 'ConnectorNo',
						minWidth: 120,
					},
					{
						title: '站点名称',
						key: 'StationName',
						minWidth: 120,
					},
					{
						title: '站点运营商',
						key: 'LocalOperatorName',
						minWidth: 120,
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						minWidth: 200,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('chargeCurves') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("view", params.row.OrderNo)
										}
									}
								}, '充电曲线') : h(),
								this.hasWidgets('push') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											if (params.row.OrderStatusDesc === "结算完成") {
												this.$Modal.confirm({
													title: '订单号:' + params.row.OrderNo,
													okText: '取消',
													cancelText: '确定',
													onCancel: () => {
														this.otherMethod(params.row
															.OrderNo);
													}
												});
											} else {
												this.$Modal.warning({
													title: "未结算完成订单",
													okText: '取消',
													//cancelText: '关闭',
												});
											}
										}
									}
								}, '重新推送') : h(),
							]);
						}
					}
				],
				columns2: [{
						title: '订单单号',
						key: 'OrderNo',
					}, {
						title: '订单时间',
						key: 'OrderTime',
					},
					{
						title: '订单来源',
						key: 'TradeType',
						render: (h, params) => {
							return h('div', params.row.TradeTypeDesc);
						}
					},
					{
						title: '订单状态',
						key: 'OrderStatus',
						render: (h, params) => {
							return h('div', params.row.OrderStatusDesc);
						}
					},
					{
						title: '流量方运营商',
						key: 'EvcsOperatorName',
						render: (h, params) => {
							return h('div', params.row.EvcsOperatorName);
						}
					},
					// {
					// 	title: '会员手机号码',
					// 	key: 'MemberPhone'
					// },
					{
						title: '同步状态',
						key: 'SyncStatusDesc'
					},
					{
						title: '预付金额(元)',
						key: 'OrderAmount'
					},
					{
						title: '充电总费用(元)',
						key: 'ChargeCost'
					},
					// {
					// 	title: '优惠金额',
					// 	key: 'CouponAmount'
					// },
					// {
					// 	title: '结算金额',
					// 	key: 'CouponCost'
					// },
					{
						title: '枪编号',
						key: 'ConnectorNo'
					},
					{
						title: '站点名称',
						key: 'StationName'
					},
					{
						title: '充电电费(元)',
						key: 'ElecCost'
					},
					{
						title: '充电服务费(元)',
						key: 'ServiceCost'
					},
					{
						title: '充电电量(度)',
						key: 'ChargeKwh'
					},
					{
						title: '起始SOC(%)',
						key: 'BeginSoc'
					},
					{
						title: '结束SOC(%)',
						key: 'EndSoc'
					},
					{
						title: '充电时长',
						key: 'ChargeDurationDesc'
					},
					{
						title: '充电前电表示值(度)',
						key: 'MeterBeginReading'
					},
					{
						title: '充电后电表示值(度)',
						key: 'MeterEndReading'
					},
					// {
					// 	title: '退款金额',
					// 	key: 'RefundAmount'
					// },
					// {
					// 	title: '退款状态',
					// 	key: 'RefundStatusDesc'
					// },
					// {
					// 	title: '退款时间',
					// 	key: 'RefundTime'
					// },
					{
						title: '车牌号',
						key: 'CarNo',
					},
					{
						title: 'VIN',
						key: 'VIN',
					},
					{
						title: '停止原因',
						key: 'TerminateReason'
					},
					// {
					// 	title: '充电卡号',
					// 	key: 'CardNo'
					// },
					// {
					// 	title: '会员手机',
					// 	key: 'MemberPhone'
					// },
					// {
					// 	title: '会员名称',
					// 	key: 'MemberName'
					// },
					{
						title: '设备编号',
						key: 'EquipmentNo'
					},
					{
						title: '枪编号',
						key: 'ConnectorNo'
					},
					{
						title: '站点名称',
						key: 'StationName'
					},
					{
						title: '站点运营商',
						key: 'LocalOperatorName'
					},
				],
				data1: []
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					OrderNo: _this.formInline.OrderNo,
					TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
					TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
					EquipmentNo: _this.formInline.EquipmentNo,
					MemberName: _this.formInline.MemberName
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			//删除修改之外的其他操作
			otherMethod: function(OrderNo) {
				this.$axios.post(webapi.base_api_url + "/Order/PushEvcsOrder", {
					OrderNo: OrderNo,
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.success('事件Id' + OrderNo + '推送成功');
						this.handleSubmit();
					}
				})
			},
			exportFile: function() {
				this.$refs.ChargingOrder.exportCsv({
					filename: '互联互通订单',
					columns: this.columns2,
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						// k.StartTime = '\t' + (k.StartTime || '');
						// k.EndTime = '\t' + (k.EndTime || '');
						// k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			},
			//操作
			show: function(type, params) {
				const _this = this
				switch (type) {
					case "view":
						_this.$refs.echartModal.show(type, params)
						break;
					default:
						break;
				}
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220 - (window.innerWidth < 1369 ? 60 : 0);
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
